import React, { FC, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate, useNavigation } from 'react-router-dom';

type Props = {};

export const AuthCheck: FC<Props> = (props) => {
  const [cookies] = useCookies(['refreshToken']);
  const nav = useNavigate();
  useEffect(() => {
    if (!cookies.refreshToken) {
      nav('/login');
    } else {
      nav('/webux');
    }
  }, [cookies.refreshToken, nav]);
  return <div></div>;
};
